import React, { useState } from "react";
import PropTypes from "prop-types";
import { Tooltip } from "reactstrap";

const DeleteAllFilterButton = ({ onClick }) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);
  const forTooltipId = "delete-all-filters";
  return (
    <button id={forTooltipId} type="button" className="as-icon" onClick={() => onClick()}>
      <span className="remove-all">Quitar todos</span>
      <Tooltip placement="top" isOpen={isOpen} target={forTooltipId} toggle={toggle}>
        Eliminar todos los filtros
      </Tooltip>
    </button>
  );
};

DeleteAllFilterButton.propTypes = {
  onClick: PropTypes.func.isRequired
};

export default DeleteAllFilterButton;
